import { Col } from "antd";
import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";

import { Button } from "../../../../../components/Button/Button";
import { ColorText } from "../../../../../components/ColorText/ColorText";
import { GoBackButton } from "../../../../../components/GoBackButton/GoBackButton";
import { ModalsContext } from "../../../../../context/modals.context";
import { MinistryContext } from "../../../../../modules/ministry/ministry.context";
import { ministryService } from "../../../../../modules/ministry/ministry.service";
import { downloadFile } from "../../../../../utils/fileDownload";
import { toastService } from "../../../../../utils/toast.service";
import { ReasonModal } from "../../../../components/StampDetails/components/ReasonModal/ReasonModal";
import { Documentation } from "../../../components/Documentation/Documentation";
import { Info } from "../../../components/Info/Info";
import { InformationAbout } from "../../../components/InformationAbout/InformationAbout";
import { Ministry } from "../../../ExciseWarehouse/MinistryWarehouseRequestDetails/components/OverviewWarehoseRequest/components/Ministry/Ministry";
import { Taxes } from "../../../ExciseWarehouse/MinistryWarehouseRequestDetails/components/OverviewWarehoseRequest/components/Taxes/Taxes";
import { DocumentTypeModal } from "./components/DocumentTypeModal/DocumentTypeModal";
import style from "./MinistryLicenceDetails.module.scss";

export const MinistryLicenceDetails = () => {
  const { handleUpdateModals, setError } = useContext(ModalsContext);
  const { ministry, setMinistry, clearMinistryState } =
    useContext(MinistryContext);
  const [dozvolaZahtevId, setDozvolaZahtevId] = useState<number | null>(null);

  let queryParams = new URLSearchParams(window.location.search);

  const createDetaljiZahtevaDozvole = async (id: number | null) => {
    const [err, res] = await to(
      ministryService.createDetaljiZahtevaDozvole({
        dozvolaZahtevId: id,
        datumResenjaNadleznogOrganaPrikaz: null,
      })
    );

    if (err || !res.success) return setError(res?.errorMessage);

    setMinistry({
      detaljiODozvoli: res.data,
    });
  };

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    createDetaljiZahtevaDozvole(Number(id));
    setDozvolaZahtevId(Number(id) || null);
    return () => {
      clearMinistryState();
    };
  }, []);

  const Kompletan = ministry.detaljiODozvoli.mfinStatusi.find(
    (zahtev) => zahtev.id === 2
  );
  const VratiNaDopunu = ministry.detaljiODozvoli.mfinStatusi.find(
    (zahtev) => zahtev.id === 3
  );
  const Odbaci = ministry.detaljiODozvoli.mfinStatusi.find(
    (zahtev) => zahtev.id === 4
  );
  const Odbij = ministry.detaljiODozvoli.mfinStatusi.find(
    (zahtev) => zahtev.id === 5
  );

  const handleDiscard = () => {
    handleUpdateModals({
      modalVisible: "reason",
      statusZahteva: Odbaci?.id,
      dozvolaZahtevId: ministry.selectedLicenceId,
      type: "odbaci",
      section: "licence",
    });
  };

  const handleReject = () => {
    handleUpdateModals({
      modalVisible: "reason",
      statusZahteva: Odbij?.id,
      dozvolaZahtevId: ministry.selectedLicenceId,
      type: "odbij",
      section: "licence",
    });
  };

  const handleReturn = () => {
    handleUpdateModals({
      modalVisible: "reason",
      statusZahteva: VratiNaDopunu?.id,
      dozvolaZahtevId: ministry.selectedLicenceId,
      type: "vrati",
      section: "licence",
    });
  };

  const postMfObradiZahtevZaDozvolu = async () => {
    const [err, res] = await to(
      ministryService.postMfObradiZahtevZaDozvolu({
        id: ministry.selectedLicenceId,
        statusZahteva: Kompletan?.id || null,
        dozvolaZahtevNote: null,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.UPDATE_STATUS_FINAL");

    setMinistry({
      mfObradiZahtevZaDozvoluId: res.data,
    });

    setTimeout(() => window.location.reload(), 300);
  };

  const handleAccept = () => {
    postMfObradiZahtevZaDozvolu();
  };

  const handleGenerateLicence = async () => {
    let queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");

    const [err, res] = await to(
      ministryService.generisiDozvolaZahtevDokument({
        dozvolaZahtevId: Number(id),
      })
    );

    if (err || !res?.success) {
      setError(res?.errorMessage);
    }
    downloadFile(
      res?.data.content!,
      ministry.detaljiODozvoli?.evidencioniBroj
        ? `${ministry.detaljiODozvoli?.evidencioniBroj}`
        : "dokument",
      "pdf"
    );
  };

  const renderTaxes = () => {
    if ((ministry.detaljiODozvoli.dokumentiIzPoreske?.length ?? 0) === 0)
      return null;
    return (
      <Taxes
        dozvolaZahtevId={dozvolaZahtevId}
        dokumentiPoreska={ministry.detaljiODozvoli.dokumentiIzPoreske}
      />
    );
  };

  const handleShowMinistry = () => {
    if (
      ministry.detaljiODozvoli.isIzvrsenaPoreskaKontrola ||
      ministry.detaljiODozvoli.isOdbijen
    )
      return (
        <Ministry
          data={ministry.detaljiODozvoli.mfinKomentari}
          isDisabled={ministry.detaljiODozvoli.isReadonly}
          licence
        />
      );
    return;
  };

  const createTitle = () => {
    if (["Nov", "Нов"].includes(queryParams.get("tipZahteva") as any))
      return t("AKCIZNE_DOZVOLE.DOBIJANJE");
    if (["Dopuna", "Допуна"].includes(queryParams.get("tipZahteva") as any))
      return t("AKCIZNE_DOZVOLE.IZMENU_RESENJA");
    if (
      ["Obnavljanje", "Обнављање"].includes(
        queryParams.get("tipZahteva") as any
      )
    )
      return t("AKCIZNE_DOZVOLE.OBNJAVLJANJE");
    if (["Prekid", "Прекид"].includes(queryParams.get("tipZahteva") as any))
      return t("AKCIZNE_DOZVOLE.PRESTANAK");
  };

  const handleLayoutButtons = () => {
    if (ministry.detaljiODozvoli?.isReadonly) {
      return null;
    }

    if (
      ministry.detaljiODozvoli.isKompletan ||
      ministry.detaljiODozvoli.isOdbacen ||
      ministry.detaljiODozvoli.isVracenNaDopunu ||
      ministry.detaljiODozvoli.isOdobren
    )
      return (
        <>
          {ministry.detaljiODozvoli.isOdobren && (
            <Ministry
              data={ministry.detaljiODozvoli.mfinKomentari}
              isDisabled={ministry.detaljiODozvoli.isReadonly}
              licence
            />
          )}
          {!ministry.detaljiODozvoli?.isReadonly ? (
            <div className={style.buttonContainer}>
              <Button onClick={handleGenerateLicence} type="primary">
                {t("COMMON.PREUZMI_ZAHTEV")}
              </Button>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    if (
      ministry.detaljiODozvoli.isIzvrsenaPoreskaKontrola ||
      ministry.detaljiODozvoli.isOdbijen
    )
      return (
        <>
          {handleShowMinistry()}
          {!ministry.detaljiODozvoli.isReadonly ? (
            <div className={style.buttonContainer}>
              <Button onClick={handleGenerateLicence} type="primary">
                {t("COMMON.PREUZMI_ZAHTEV")}
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  handleUpdateModals({
                    modalVisible: "tipResenja",
                    type: "resenje",
                    data: ministry.detaljiODozvoli
                      .akciznoSkladisteTipoviResenja,
                  })
                }
                className="ml-20"
              >
                {t("COMMON.GENERISANJE_RESENJA")}
              </Button>
              <Button
                className="ml-20"
                type="primary"
                onClick={() =>
                  handleUpdateModals({
                    modalVisible: "tipResenja",
                    data: ministry.detaljiODozvoli
                      .akciznoSkladisteTipoviResenja,
                  })
                }
              >
                {t("COMMON.ZAVRSI")}
              </Button>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    if (
      ministry.detaljiODozvoli.isPodnet &&
      !ministry.detaljiODozvoli.isReadonly
    )
      return (
        <>
          <div className={style.buttonCol}>
            <Button onClick={handleGenerateLicence} type="primary">
              {t("COMMON.PREUZMI_ZAHTEV")}
            </Button>
            <Button
              onClick={handleReject}
              className={`${style.redButton} ml-20`}
            >
              {t("COMMON.ODBIJ")}
            </Button>
            <Button
              onClick={handleDiscard}
              className={`${style.redButton} ml-20`}
            >
              {t("COMMON.ODBACI")}
            </Button>
            <Button onClick={handleReturn} className={style.semiRedButton}>
              {t("COMMON.VRATI_NA_DOPUNU")}
            </Button>
            <Button onClick={handleAccept} className="ml-20" type="primary">
              {t("COMMON.KOMPLETAN")}
            </Button>
          </div>
        </>
      );
  };

  return (
    <div className={style.mainContainer}>
      <DocumentTypeModal />
      <ReasonModal />
      <GoBackButton
        routePath="/mfin/listaDozvola"
        options={{ state: { usePersistedFilters: true } }}
      />
      <h2 className={style.fontSize}>
        {t("AKCIZNE_DOZVOLE.ZAHTEV_ZA")} {createTitle()}{" "}
        {t("AKCIZNE_DOZVOLE.AKCIZNE_DOZVOLE")} {queryParams.get("id")}
      </h2>
      <h3 className={style.title}>
        {ColorText(ministry.detaljiODozvoli.statusZahteva)}
      </h3>
      <div className={style.evidencioniBroj}>
        {t("AKCIZNE_MARKICE.EVIDENCIONI_BROJ")}:{" "}
        {ministry.detaljiODozvoli.evidencioniBroj}
      </div>
      <InformationAbout
        data={ministry.detaljiODozvoli.drustvoInformacije}
        type={t("AKCIZNE_MARKICE.KORISNIKU")}
      />
      {ministry.detaljiODozvoli.showPrekidVazenjaNote && (
        <Col span={24}>
          <div className={style.prekidVazenjaNote}>
            {ministry.detaljiODozvoli.prekidVazenjaNote}
          </div>
        </Col>
      )}
      <Info type={true} data={ministry.detaljiODozvoli} />
      <Documentation
        data={ministry.detaljiODozvoli.dokumentiZaDozvolu}
        kategorijaProizvodaId={
          ministry.detaljiODozvoli?.dozvolaInformacije?.kategorijaProizvodaId
        }
      />
      {renderTaxes()}
      {handleLayoutButtons()}
    </div>
  );
};
